import { inject, nextTick } from "vue";

export default function (isDesign, widgetList, indexOfParentList ) {
  const { updateSelectWidget } = inject("designer");

  const clickWidget = (widget) => {
    if (!!isDesign.value) {
      updateSelectWidget(widget);
    }
  };

  const moveUpWidget = () => {
    if (indexOfParentList.value > 0) {
      let nextSelected = widgetList.value[indexOfParentList.value - 1];
      widgetList.value[indexOfParentList.value - 1] =
        widgetList.value[indexOfParentList.value];
      widgetList.value[indexOfParentList.value] = nextSelected;
    } else {
      return;
    }
  };
  const moveDownWidget = () => {
    if (indexOfParentList.value < widgetList.value.length - 1) {
      let nextSelected = widgetList.value[indexOfParentList.value + 1];
      widgetList.value[indexOfParentList.value + 1] =
        widgetList.value[indexOfParentList.value];
      widgetList.value[indexOfParentList.value] = nextSelected;
    } else {
      return;
    }
  };
  const removeFieldWidget = () => {
    let nextSelected = null;
    if (widgetList.value.length === 1 + indexOfParentList.value) {
      nextSelected = widgetList.value[indexOfParentList.value - 1];
    } else {
      nextSelected = widgetList.value[indexOfParentList.value + 1];
    }

    nextTick(() => {
      widgetList.value.splice(indexOfParentList.value, 1);

      updateSelectWidget(nextSelected);
    });
  };

  return {
    moveUpWidget,
    moveDownWidget,
    removeFieldWidget,
    clickWidget,
  };
}
